// frontend/src/services/authService.ts
import axios from 'axios';
// 1. Importar a instância 'api' e o 'backendHost' do apiConfig
import api, { backendHost } from './apiConfig';

// 2. A URL base para o login (que não usa a instância 'api')
const API_BASE_URL = backendHost.replace('/api', '');

/** Login local (com ID lookup) */
export const loginAPI = async (usuario: string, senha: string) => {
    // 3. O login DEVE usar axios puro, pois o interceptor 'api'
    // tentaria injetar um token que ainda não existe.
    const response = await axios.post(`${API_BASE_URL}/api/auth/login`, {
        usuario,
        senha,
    });
    
    // Se o login for bem-sucedido, salva o token no localStorage do navegador
    if (response.data.token) {
        localStorage.setItem('userToken', response.data.token);
    }

    return response.data;
};

/** Login cloud/AWS — sem ID, sem lookup, sem salvar token no localStorage */
export const cloudLoginAPI = async (usuario: string, senha: string) => {
    const response = await axios.post(`${API_BASE_URL}/api/cloud-auth/login`, {
        usuario,
        senha,
    });

    if (response.data.token) {
        localStorage.setItem('userToken', response.data.token);
    }

    return response.data;
};

export const logoutAPI = async () => {
    // Salva o token antes de remover (caso precise para a requisição de logout)
    const token = localStorage.getItem('userToken');

    // IMPORTANTE: Remove o token ANTES de fazer a requisição
    // Isso garante que nenhum polling ou requisição paralela use o token
    localStorage.removeItem('userToken');

    try {
        // Chamar o endpoint de logout no backend para remover sessão
        // Usa o token salvo explicitamente
        await api.post('/auth/logout', {}, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    } catch (error) {
        console.error('Erro ao fazer logout no backend:', error);
        // Continua mesmo com erro, pois o logout local é mais importante
    }
};

export const logout = () => {
    // Esta função é chamada pela store, mas
    // manter a limpeza do localStorage aqui é uma boa prática.
    localStorage.removeItem('userToken');
};

export const getToken = () => {
    return localStorage.getItem('userToken');
};

export const getUserByIdAPI = async (id: string) => {
    try {
        const response = await api.get(`/auth/user/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getUserByNameAPI = async (username: string) => {
    try {
        const response = await api.get(`/auth/user/search/${encodeURIComponent(username)}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getUserEmpresaAPI = async () => {
    try {
        const response = await api.get('/auth/empresa');
        return response.data as { empresa: string; baseId: number; regional?: string };
    } catch (error) {
        console.error('Erro ao buscar empresa do usuário:', error);
        return { empresa: 'KADESH', baseId: 0 };
    }
};